import { sleep } from './utils'

export const recognition =
  // eslint-disable-next-line no-undef
  new webkitSpeechRecognition() || new SpeechRecognition()
recognition.continuous = false
recognition.lang = 'en-US'
recognition.interimResults = true
recognition.maxAlternatives = 1

export const speechStatus = { current: false }
export const speechResults = { current: null }

export const startRecognition = (
  gotTempResult,
  gotFinalResult,
  speechButtonPressed
) => {
  if (!speechButtonPressed.current) {
    speechButtonPressed.current = true

    recognition.onstart = function () {
      speechStatus.current = true
    }

    if (!speechStatus.current) recognition.start()

    recognition.onresult = function (e) {
      const result = e.results[0][0].transcript
      if (result.length) {
        gotTempResult(result)
        speechResults.current = result
        console.log('TEMP', result)
      }
    }

    recognition.onend = function () {
      console.log('FINAL', speechResults.current)
      if (speechResults.current) gotFinalResult(speechResults.current)
      speechStatus.current = false
      speechResults.current = null
      recognition.stop()
    }
  }
}

export const stopRecognition = speechButtonPressed => {
  console.log('RECOGNITION END')
  sleep(100).then(() => {
    speechButtonPressed.current = false
    recognition.stop()
  })
}
